// @/workers/timerWorker.ts
// 定时器 worker

export default `const timers = {} // 存储定时器 ID
self.onmessage = (event) => {
  const { id, delay, action } = event.data

  if (action === 'start') {
    timers[id] && clearTimeout(timers[id])
    timers[id] = setTimeout(() => {
      const result = 'setTimeout ID: ' + id
      self.postMessage({ result, id })
      delete timers[id] // 清理已完成的定时器
    }, delay)
  } else if (action === 'clear') {
    if (timers[id]) {
      clearTimeout(timers[id])
      delete timers[id] // 清除定时器后，移除引用
    }
  }
}`
